import * as React from 'react'

import createContext from 'modules/core/hooks/createContext'
import { useCallback } from 'modules/core/hooks/useCallback'

import type { PermissionsDispatch, PermissionsState, PermissionsType } from './reducers/permissions'
import reducer, { initialPermissionsState } from './reducers/permissions'

type Context = [PermissionsState, PermissionsDispatch]

const { context: PermissionsContext, hook: usePermissions } = createContext<Context>()

interface ProviderType {
  permissions?: PermissionsType
}

const PermissionsProvider = ({ permissions, children }: React.PropsWithChildren<ProviderType>) => {
  const memoizedReducer = useCallback(reducer, [])

  const [state, dispatch] = React.useReducer(
    memoizedReducer,
    initialPermissionsState({
      permissions,
    })
  )
  return (
    <PermissionsContext.Provider value={[state, dispatch]}>{children}</PermissionsContext.Provider>
  )
}

export { PermissionsProvider, usePermissions }
